import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import React, { useState, useCallback, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "../../Misc/Modal";
import SendIcon from "./SendIcon";
import UseIcon from "./UseIcon";
import BusyIcon from "./BusyIcon";
import ChatGPTIcon from "./ChatGPTIcon";
import QuestionIcon from "./QuestionIcon";
import BigLoadingIcon from "./BigLoadingIcon";
import TypewriterText from "./TypewriterText";

function ScriptGenerationAssistant(_ref) {
  var _this = this;

  var isActive = _ref.isActive,
      onReady = _ref.onReady,
      onClose = _ref.onClose,
      assistScriptGeneration = _ref.assistScriptGeneration;
  var logRef = useRef();

  var _useState = useState(false),
      isBusy = _useState[0],
      setIsBusy = _useState[1];

  var _useState2 = useState(""),
      question = _useState2[0],
      setQuestion = _useState2[1];

  var _useState3 = useState([]),
      history = _useState3[0],
      setHistory = _useState3[1];

  var trackQuestionChange = useCallback(function (e) {
    setQuestion(e ? e.currentTarget.textContent : "");
  }, []);
  var useAsScript = useCallback(function (historyRecordIndex) {
    onReady(history[historyRecordIndex].content);
    onClose();
  }, [history, onReady]);
  var questionRef = useRef();
  useEffect(function () {
    if (!!question || !questionRef.current) {
      return;
    }

    questionRef.current.innerText = "";
  }, [question]);
  var handleQuestionSubmit = useCallback(function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(e) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(e.charCode && e.charCode !== 13)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              e.preventDefault();

              if (!(isBusy || !question)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              setIsBusy(true);
              _context.next = 8;
              return assistScriptGeneration(question, history);

            case 8:
              result = _context.sent;
              setHistory(result);
              setIsBusy(false);
              trackQuestionChange();
              questionRef.current.focus();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [trackQuestionChange, history, question, isBusy, setIsBusy]);
  var handleEditableDivPaste = useCallback(function (e) {
    e.preventDefault();
    document.execCommand("insertHTML", false, e.clipboardData.getData("text/plain"));
  }, []);
  var regenerate = useCallback(_asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var newHistory, lastQuestion, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isBusy) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            setIsBusy(true);
            newHistory = history.slice(0, history.length - 2);
            lastQuestion = history[history.length - 2].content;
            _context2.next = 7;
            return assistScriptGeneration(lastQuestion, newHistory);

          case 7:
            result = _context2.sent;
            setHistory(result);
            setIsBusy(false);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  })), [trackQuestionChange, history, question, isBusy, setIsBusy]);
  useEffect(function () {
    logRef.current.scrollTop = logRef.current.scrollHeight;
  }, [history]);
  useEffect(function () {
    return setHistory([]);
  }, [isActive]);
  return React.createElement(Modal, {
    active: isActive,
    className: "script-assistant"
  }, React.createElement("div", {
    className: "script-assistant-container"
  }, React.createElement("div", {
    className: "script-assistant-log",
    ref: logRef
  }, history.map(function (_ref4, index) {
    var variant = _ref4.variant,
        content = _ref4.content;
    var applyTypewriterEffect = index === history.length - 1 && variant === "answer";
    return React.createElement("div", {
      key: index,
      className: "record " + variant
    }, variant === "answer" ? React.createElement(ChatGPTIcon, null) : React.createElement(QuestionIcon, null), applyTypewriterEffect ? React.createElement(TypewriterText, null, content) : content, variant === "answer" && React.createElement("span", {
      className: "use-button",
      onClick: function onClick() {
        return useAsScript(index);
      },
      title: "Transfer to Teleprompter"
    }, React.createElement(UseIcon, null)));
  })), isBusy && React.createElement("div", {
    style: {
      position: "absolute",
      bottom: 120,
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "center"
    }
  }, React.createElement(BigLoadingIcon, null)), !isBusy && history.find(function (record) {
    return record.variant === "answer";
  }) && React.createElement("div", {
    style: {
      position: "absolute",
      bottom: 120,
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "center"
    }
  }, React.createElement("button", {
    className: "button button--size-m ripple",
    style: {
      border: "solid 1px #ececf1d9",
      padding: 10,
      borderRadius: 5
    },
    onClick: regenerate
  }, "Regenerate")), React.createElement("div", {
    className: "script-assistant-textarea"
  }, React.createElement("div", {
    ref: questionRef,
    contentEditable: !isBusy,
    onInput: trackQuestionChange,
    onKeyPress: handleQuestionSubmit,
    style: {
      paddingRight: 30
    },
    onPaste: handleEditableDivPaste
  }), React.createElement("button", {
    className: "send-button"
  }, isBusy ? React.createElement(BusyIcon, null) : React.createElement(SendIcon, {
    onClick: handleQuestionSubmit
  }))), React.createElement("div", {
    className: "modal__buttons"
  }, React.createElement("button", {
    className: "button button--size-m",
    onClick: onClose
  }, "Close"))));
}

ScriptGenerationAssistant.propTypes = process.env.NODE_ENV !== "production" ? {
  onReady: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  assistScriptGeneration: PropTypes.func.isRequired
} : {};
export default ScriptGenerationAssistant;